import { jsPDF } from "jspdf";

// Generates and downloads the ZATCA certificate details PDF for a single
// per-device ZATCA configuration. Shared by the outlet listing and view pages.
export const generateZatcaPdf = (cfg) => {
    const data = cfg?.zatca_details || {};
    const doc = new jsPDF();
    let yPosition = 14;
    const marginLeft = 8;
    const maxWidth = 180;

    // Increased heading font size, decreased value font size
    const headingFontSize = 14;  // Larger font size for headings
    const valueFontSize = 10;     // Smaller font size for values

    const pageHeight = doc.internal.pageSize.height;
    const lineHeight = 5;  // Line height to control spacing
    const sectionGap = 4;  // Additional gap between sections (heading and next value)

    // Function to add text with wrapping
    const addFileHeading = (value) => {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);
        doc.text(value, 68, yPosition);

        // Add a gap before the next section (heading and value)
        yPosition += 2 * sectionGap;  // Adjust this gap to your preference
    };
    const addTextWithWrap = (label, value) => {
        const labelText = `${label}: `;
        const wrappedLabelText = doc.splitTextToSize(labelText, maxWidth);
        const wrappedValueText = doc.splitTextToSize(value, maxWidth);

        const spaceRequired = (wrappedLabelText.length + wrappedValueText.length) * lineHeight;

        // Check if there’s enough space for the text, if not, add a page
        if (yPosition + spaceRequired > pageHeight - 10) {
            doc.addPage();
            yPosition = 8;
        }

        // Add the label (heading)
        doc.setFont("helvetica", "bold");
        doc.setFontSize(headingFontSize);
        wrappedLabelText.forEach(line => {
            doc.text(line, marginLeft, yPosition);
            yPosition += lineHeight;
        });

        // Add the value (body text)
        doc.setFont("helvetica", "normal");
        doc.setFontSize(valueFontSize);
        wrappedValueText.forEach(line => {
            doc.text(line, marginLeft + 14, yPosition);  // Indent the value a bit
            yPosition += lineHeight;
        });

        // Add a gap before the next section (heading and value)
        yPosition += sectionGap;  // Adjust this gap to your preference
    };

    // Data fields to add
    addFileHeading("Zatca Certificate Details");
    addTextWithWrap("Configuration Name", cfg?.configuration_name || "N/A");
    addTextWithWrap("Configuration Type", cfg?.configuration_type?.toUpperCase() || "N/A");
    addTextWithWrap("Environment", data?.zatca_environment_type?.toUpperCase() || "N/A");
    addTextWithWrap("Organization Name", data?.vat_name || "N/A");
    addTextWithWrap("VAT Number", data?.vat_number || "N/A");
    addTextWithWrap("Organization Unit Name", data?.organisation_unit_name || "N/A");
    addTextWithWrap("Street", data?.street || "N/A");
    addTextWithWrap("Building", data?.building || "N/A");
    addTextWithWrap("Plot Identification", data?.plot_identification || "N/A");
    addTextWithWrap("City Subdivision", data?.city_subdivision || "N/A");
    addTextWithWrap("Postal Zone", data?.postal_zone || "N/A");
    addTextWithWrap("Private Key", data?.private_key || "N/A");
    addTextWithWrap("CSR", data?.csr || "N/A");
    addTextWithWrap("Compliance Request ID", data?.compliance_request_id || "N/A");
    addTextWithWrap("Compliance Certificate", data?.compliance_certificate || "N/A");
    addTextWithWrap("Compliance Secret", data?.compliance_secret || "N/A");
    addTextWithWrap("Production Request ID", data?.production_request_id || "N/A");
    addTextWithWrap("Production Certificate", data?.production_certificate || "N/A");
    addTextWithWrap("Production Secret", data?.production_secret || "N/A");
    addTextWithWrap("Last Invoice Hash", data?.last_invoice_hash || data?.previous_invoice_hash || cfg?.previous_invoice_hash || "N/A");
    addTextWithWrap("Last Invoice Counter Number", String(data?.last_invoice_counter_number ?? cfg?.last_invoice_counter_number ?? "N/A"));
    addTextWithWrap("Public Key", data?.public_key || "N/A");

    // Save the document
    doc.save(`zatca_details_${cfg?.configuration_name || cfg?.id || 'config'}.pdf`);
};
